import type { User } from "../@types/services/User";
import { config } from "../config";

export const subscribeUserMessageChannel = (
  user: Pick<User, "id">,
  type: string,
  onMessageCallback: (data: string) => void,
  callbacks?: { onOpen?: () => void; onError?: () => void },
): (() => void) => {
  if (!config.mercure.hubUrl) {
    console.warn("Mercure hub URL is not configured.");
    return () => {};
  }

  const url = new URL(config.mercure.hubUrl);
  url.searchParams.append(
    "match_urlpattern",
    `${window.location.origin}/users/${user.id}/${type}`,
  );

  const eventSource = new EventSource(url, { withCredentials: true });

  eventSource.onmessage = ({ data }) => {
    onMessageCallback(data);
  };
  eventSource.onopen = () => callbacks?.onOpen?.();
  eventSource.onerror = () => {
    if (callbacks?.onError) callbacks.onError();
    else
      console.warn("Mercure connection interrupted; waiting for reconnection.");
  };

  return () => eventSource.close();
};
